<template>
  <div class="approval" v-if="fjShow">
    <van-cell title="订单附件" is-link value-align="left" class="cell">
      <template #right-icon>
        <van-uploader
          :after-read="afterRead"
          v-model="fileList"
          :preview-image="false"
        >
          <ld-button
            size="sm"
            @click.stop="$emit('revert-approval', item)"
            style="width: 65px;padding:0px"
            class="main-color fjup"
          >
            {{ $t('B068','上传附件') }}
          </ld-button>
          <!-- <ld-icon
              icon-class="main-color"
              size="16"
              type="iconshangchuan"
            /> -->
        </van-uploader>
      </template>
    </van-cell>
    <van-list
      v-model="loading"
      :finished="finished"
      :finished-text="showFinished?'没有更多了':''"
      @load="onLoad"
    >
      <van-cell
        v-for="(item, index) in fileList"
        :key="index"
        :title="item.file.name+(index+1)"
      >
        <ld-button
          main2
          size="sm"
          @click="imgShow(item.content)"
          style="width: 60px"
        >
          {{ $t('C112','查看') }}
        </ld-button>
        <ld-button
          v-show="orderStatus!='5' || orderStatus!='6' || orderStatus!='7' || orderStatus!='9'"
          defaults
          size="sm"
          @click="delImg(index)"
          style="width: 60px; margin-left: 5px"
        >
          {{ $t('B052','删除') }}
        </ld-button>
        <!-- <van-button round  type="info" size="mini" text="查看" />
        <van-button round  type="danger" size="mini" text="删除" /> -->
      </van-cell>
    </van-list>
    <van-popup v-model="imgshow" :style="{ width: '90%' }">
      <img :src="src" alt="" :style="{ width: '100%' }" @click="imgshow=false">
    </van-popup>
  </div>
</template>

<script>
import { Cell, Uploader, CellGroup, List, Popup,Icon,Notify } from "vant";
import { API_DEFAULT_CONFIG } from "Config";
import { localget} from 'Utils/storage.js'
import ldButton from "Common/ldButton";
import axios from 'axios'


export default {
  name: "ldUploader",
  components: {
    [Cell.name]: Cell,
    [Uploader.name]: Uploader,
    [CellGroup.name]: CellGroup,
    [List.name]: List,
    [Popup.name]: Popup,
    [Icon.name]: Icon,
    [Notify.name]: Notify,
    ldButton,
  },
  props: {
    orderId: {
      type: String,
      default: ''
    },
    glywlx: {
      type: String,
      default: ''
    },
    cjlx: {
      type: Number,
      default: ''
    },
    showFinished: {
      type: Boolean,
      default: true
    },
    orderStatus:{
      type:String,
      default:'1'
    }
  },
  data() {
    return {
      src: "",
      fileList: [],
      uploadFileList:[],
      loading: false,
      finished: true,
      imgshow: false,
      fjShow:false,
    };
  },
  created () {
    this.getQueryFj()
    this.isAllCheckApprover()
  },
  methods: {
    async isAllCheckApprover () {
      let { data = {} } = await this.$api['common/getParameter']({paramNo: 20032})
      let value1 = data.value1
      if (value1 == 1) this.fjShow = true
    },
    afterRead(file) {
      this.uploaderFun(file.file,-1)
    },
    onLoad() {
      
    },
    imgShow(img) {
      this.imgshow = !this.imgshow;
      this.src = img;
    },
    delImg(index) {
      this.fileList.splice(index, 1);
      this.uploadFileList.splice(index,1)
      this.uploadCons('delImg')
    },
    uploaderFun (file, timeout) {
      let formData = new FormData();
      let token = localget('access_token')
      formData.append("file",file);
      formData.append("token", token);
      formData.append("sysCode", 7000);
      formData.append("timeout", timeout);
      axios({
        url: API_DEFAULT_CONFIG.URL.uploadFileUrl,
        method: "post",
        data: formData,
        contentType: false,
        processData: false,
      }).then(res=>{
        if(res.data.errCode == '1'){
          this.uploadFileList.push(res.data.data)
          this.uploadCons()
        }else{

        }
      });
    },
    uploadCons (upType){ //订单附件上传
      let fjUrl = undefined
      if(this.uploadFileList.length>0){
        fjUrl = this.uploadFileList.join(',')
      }
      const beanList = [{
        cjlx:this.cjlx||'',// (integer, optional): 场景类型 1 非自愿退凭证2订单附件 ,
        glywlx:this.glywlx||'',// (string, optional): 关联业务类型 ,
        gldd:this.orderId||'',// (string, optional): 关联订单id ,
        fjUrl:fjUrl,// (string, optional): 附件url 多个逗号分割
      }]
      this.$api['common/uploadCons']({beanList:beanList}).then(res=>{
        if(res.errCode=='1'){
          if(upType){
            Notify({ type: 'success', message: '附件已删除'});
          }else{
            Notify({ type: 'success', message: '文件上传成功！'});
          }
        }else{
          Notify({ type: 'danger', message: '文件上传失败！' });
        }
      })
    },
    getQueryFj () {
      const data = {
        cjlx:this.cjlx,// (integer, optional): 场景类型 1 非自愿退凭证2订单附件 ,
        glywlx:this.glywlx,// (string, optional): 关联业务类型 ,
        gldd:this.orderId,// (string, optional): 关联订单id
      }
      this.$api['common/queryFj'](data).then(res=>{
        if(res.errCode=='1'){
          let fjArr = res.data.fjUrl.split(',')
          this.uploadFileList = fjArr
          fjArr.forEach(element => {
            let filed = {
              content:element,
              file:{
                name:'附件'
              }
            }
            this.fileList.push(filed)
          });
        }
      })
    }
  },
};
</script>

<style scoped lang="less">
.fjup{
  border: 1px solid @color-text-main;
}
</style>
